import * as React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import Pagination from '@mui/material/Pagination'

import SoundPopUp from '../../funtComponents/popUpSound';

import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { arreglo, changeIp, audioVacio2, secondsToString, forMiles, formatearFecha, constertarTraductor, mapStateToProps, puntoPorComa } from '../../../components/funtComponents/models/buscar'

import { connect } from 'react-redux';



function Row({ name, I1, I2, I3, I4, I5, I6, I7, I8, objFiltrar, entrantes }) {
    //test
    
    const [testAudio, setTestAudio] = React.useState([])
    const [page, setPage] = React.useState(0);
    const [page2, setPage2] = React.useState(10);

    const [open, setOpen] = React.useState(false);
    const [temporal, setTemporal] = React.useState(null)
    const [temporalTitle, setTemporalTitle] = React.useState(null)

    


    function filtrarPorID(obj) {
        if (obj.chan1 === objFiltrar) {
            return obj;
        }
    }

    const audio = Object.values(entrantes).filter(filtrarPorID)

    const handleChange = (event, value) => {
        
        paginacion(audio, value*10)
        setPage2(value * 10);
        setPage(value);
        
    };

    //interactuan con el SoundPopUp

    const [openpop, setOpenPop] = React.useState(false);
    const handleClickOpen = (sound, title) => {
        setTemporal(sound)
        setTemporalTitle(title)
        setOpenPop(true);
    };
    const handleClose = () => {
        setOpenPop(false);
    };
    const paginacion = (audio2, pagIni2) => {
        let forVal = audio2.slice((pagIni2-10) , pagIni2)
        
        setTestAudio(forVal);
    }
    const handleAudio = (item, pag) => {
        
        paginacion(item, pag)
        setOpen(!open)
    };
//raymer
    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} style={{ backgroundColor: open ? 'rgba(214, 44, 44, 0.6)' : null, color: '#000' }}>
                <TableCell style={{ width: 20, }}>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => handleAudio(audio, page2)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row" style={{ color: '#000' }}>
                    {name}
                </TableCell>
                <TableCell align="center">{forMiles(I1)}</TableCell>
                <TableCell align="center">{forMiles(I2)}</TableCell>
                <TableCell align="center">{I3}</TableCell>
                <TableCell align="center">{I4}</TableCell>
                <TableCell align="center">{I5}</TableCell>
                <TableCell align="center">{I6}</TableCell>
                <TableCell align="center">{I7}</TableCell>
                <TableCell align="center">{I8}</TableCell>

            </TableRow>

            {/**EXPAND INIT */}
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0, }} colSpan={10}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

                            <Table size="small" aria-label="purchases">
                                <TableHead style={{ backgroundColor: 'rgba(73, 73, 73, 0.1)', color: '#000' }}>
                                    <TableRow>
                                        <TableCell style={{ fontSize: 12, fontWeight: 400, width: 100 }} align="center">Audio</TableCell>
                                        <TableCell style={{ fontSize: 12, fontWeight: 400 }} align="center">Fecha</TableCell>
                                        <TableCell style={{ fontSize: 12, fontWeight: 400 }} align="center">Desde</TableCell>
                                        <TableCell style={{ fontSize: 12, fontWeight: 400 }} align="center">Hacia</TableCell>
                                        <TableCell style={{ fontSize: 12, fontWeight: 400 }} align="center">Tiempo facturable</TableCell>
                                        <TableCell style={{ fontSize: 12, fontWeight: 400 }} align="center">Tiempo de repique</TableCell>
                                        <TableCell style={{ fontSize: 12, fontWeight: 400 }} align="center">Disposición</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>


                                    {

                                        testAudio.map((item) =>{
                                            let audioVacio = false
                                            if(constertarTraductor(item.disposition) !== 'CONTESTADA'){
                                                 audioVacio = true;
                                            }
                                            return(
                                            <TableRow key={item.date} style={{ backgroundColor: 'rgba(73, 73, 73, 0)' }}>


                                                <TableCell style={{ fontSize: 12, fontWeight: 400 }} align="center" component="th" scope="row">
                                                    <PlayCircleOutlineIcon
                                                        onClick={() => { audioVacio === true ? audioVacio2() : handleClickOpen(changeIp(item.recording), item.disposition)}}
                                                        style={{ width: 20, color: audioVacio === true ? 'grey' : 'rgba(214, 44, 44, 0.8)', cursor: 'pointer' }} />
                                                </TableCell>
                                                <TableCell style={{ fontSize: 12, fontWeight: 400 }} align="center">{formatearFecha(item.calldate)}</TableCell>
                                                <TableCell style={{ fontSize: 12, fontWeight: 400 }} align="center">{item.src}</TableCell>
                                                <TableCell style={{ fontSize: 12, fontWeight: 400 }} align="center">{item.dst}</TableCell>
                                                <TableCell style={{ fontSize: 12, fontWeight: 400 }} align="center">{secondsToString(item.billsec)}</TableCell>
                                                <TableCell style={{ fontSize: 12, fontWeight: 400 }} align="center">{secondsToString(item.ringtime)}</TableCell>
                                                <TableCell style={{ fontSize: 12, fontWeight: 400 }} align="center">{constertarTraductor(item.disposition)}</TableCell>

                                                <SoundPopUp temporalTitle={temporalTitle} temporal={temporal} openpop={openpop} setOpenPop={setOpenPop} handleClickOpen={handleClickOpen} handleClose={handleClose} />


                                            </TableRow>

                                        )
                                    })

                                    }

                                </TableBody>

                            </Table>

                            <TableRow style={{ display: 'flex', flexDirection: 'row', width: '100%', height: 60,  alignItems: 'center', justifyContent: 'center' }}>
                               
                                <div style={{ display: 'flex', flexDirection: 'row', flex: 1, backgroundColor: 'green' }}>

                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', flex: 1, }}>
                                    <Pagination style={{ width: '100%', alignSelf: 'center', display: 'flex' }} size="large" count={Math.ceil(I1/10)} page={page} onChange={handleChange} />

                                </div>


                                <div style={{ display: 'flex', flexDirection: 'row', flex: 1, }}>

                                </div>
                            </TableRow>

                        </Box>

                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}



function CollapsibleTable(props) {
    const resuelto = arreglo(props.entrantes, props.rightAnexos)






    return (

        <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
                <TableHead>
                    <TableRow style={{ backgroundColor: 'lightgrey', color: '#000', fontWeight: 600 }}>
                        <TableCell />
                        <TableCell align="left">Usuario</TableCell>
                        <TableCell align="right">Cantidad</TableCell>
                        <TableCell align="right">Fallidas</TableCell>
                        <TableCell align="right">% Fallidas</TableCell>
                        <TableCell align="right">Tiempo Facturable</TableCell>
                        <TableCell align="right">% Tiempo Facturable</TableCell>
                        <TableCell align="right">Duración promedio</TableCell>
                        <TableCell align="right">Tiempo total Ring</TableCell>
                        <TableCell align="right">Promedio Ring</TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        resuelto.map((user) => {

                           
                            return (
                            <Row
                                key={user.name}
                                name={user.name}
                                I1={isNaN(user.cantidad) ? 0 : user.cantidad }
                                I2={isNaN(user.fallidas) ? 0 : user.fallidas }
                                I3={puntoPorComa(isNaN(parseFloat(parseFloat(user.fallidas*100)/(user.cantidad)).toFixed(0)) ? 0 : parseFloat(parseFloat(user.fallidas*100)/(user.cantidad)).toFixed(0))+'%'}
                                I4={secondsToString(isNaN(user.billsec) ? 0 : user.billsec)}
                                I5={puntoPorComa(isNaN(parseFloat((parseFloat(user.duration)-parseFloat(user.ring))*100/user.billsec).toFixed(0))? 0 :parseFloat((parseFloat(user.duration)-parseFloat(user.ring))*100/user.billsec).toFixed(0) )+'%'}
                                I6={secondsToString(user.duration/user.cantidad)}
                                I7={secondsToString(user.ring)}
                                I8={secondsToString(user.ring/user.cantidad)}
                                objFiltrar={user.chan1}
                                entrantes={props.entrantes}
                            />
                        ) 
                    })
                    }
                </TableBody>
            </Table>
        </TableContainer>
    );
}





export default connect(mapStateToProps, null)(CollapsibleTable);